'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var d3 = require('d3');

// avoiding Array.from due to compability issues
var setToArray = function setToArray(set) {
  var holder = [];
  set.forEach(function (item) {
    return holder.push(item);
  });
  return holder;
};
function createSpanVizualizationFactory(renderLoop) {
  /**
   * returns a component for table rendering that is scoped to one 
   * shared rendering loop
   */
  return function (getContainer, additionalProps) {
    var scope = {
      components: new Set(),
      elements: [],
      pending: true
    };
    var scopeToData = function scopeToData(scope) {
      var rects = scope.elements.map(function (e) {
        return e.getBoundingClientRect();
      });
      var componentsList = setToArray(scope.components);
      var data = componentsList.map(function (c) {
        return c.props.value;
      });
      var labels = componentsList.map(function (c) {
        return c.props.label;
      });
      var colors = componentsList.map(function (c) {
        return c.props.color;
      });
      var min = {
        x: d3.min(rects, function (r) {
          return r.left;
        }),
        y: d3.min(rects, function (r) {
          return r.top;
        })
      };
      return _extends({
        getContainer: getContainer,
        min: min,
        width: d3.max(rects, function (r) {
          return r.right;
        }) - min.x,
        height: d3.max(rects, function (r) {
          return r.bottom;
        }) - min.y,
        data: data.map(function (d, i) {
          return _extends({}, d, {
            rect: {
              offsetX: rects[i].left - min.x,
              offsetY: rects[i].top - min.y
            }
          });
        }),
        labels: labels.filter(function (l) {
          return !!l;
        }).length ? labels : [],
        colors: colors.filter(function (c) {
          return !!c;
        }).length ? colors : []
      }, additionalProps || {});
    };
    var D3LikertBars = function (_React$PureComponent) {
      _inherits(D3LikertBars, _React$PureComponent);
      function D3LikertBars(props) {
        _classCallCheck(this, D3LikertBars);
        var _this = _possibleConstructorReturn(this, (D3LikertBars.__proto__ || Object.getPrototypeOf(D3LikertBars)).call(this, props));
        _this.registerElement = _this._registerElement.bind(_this);
        _this.appendElement = _this._appendElement.bind(_this);
        return _this;
      }
      _createClass(D3LikertBars, [{
        key: '_registerElement',
        value: function _registerElement(elem) {
          if (this.index) {
            scope.elements[this.index] = elem;
            return;
          }
          this.index = this.appendElement(this, elem);
        }
      }, {
        key: '_appendElement',
        value: function _appendElement(component, elem) {
          if (scope.components.has(component)) return;
          scope.components.add(component);
          scope.elements.push(elem);
          if (scope.pending) {
            // where the initial table layout is essentially synchronous,
            // this nextTick() should be sufficient 
            process.nextTick(function () {
              renderLoop(scopeToData(scope), true);
            });
            scope.pending = false;
          }
          return scope.components.size - 1;
        }
        // didmount - bind to window resize
      }, {
        key: 'render',
        value: function render() {
          var value = this.props.value;

          // legible version of the data (accessibility)

          var text = (additionalProps && additionalProps.scale || Object.keys(value)).map(function (key) {
            return key + ': ' + Math.round(value[key] * 100.0) + '%';
          }).join('; ');
          return _react2.default.createElement('td', {
            ref: this.registerElement,
            className: 'span-cells',
            'aria-label': text
          }, '\xA0');
        }
      }]);
      return D3LikertBars;
    }(_react2.default.PureComponent);
    return D3LikertBars;
  };
}
exports.default = createSpanVizualizationFactory;